import React from "react";
import { useState, useEffect, useRef } from "react";
import {
  checkIfItemIsIntheList,
  getUniqueRecordsAgainstNthColumn,
} from "../Shared/Utility";
type Props = {
  DataType: number;
  GridData: any;
  ColumnName: string;
  RefreshFilters: boolean;
  GetFilteredLists: boolean;
  ColumnFilterCheckboxListCallback: any;
  ReturnAllFilterdLists: any;
  ClickPosition: any;
  Orientation: string;
  ColumnOrientation: any;
};
function ColumnFilterCheckboxList(props: Props) {
  const [listOfList, setListOfList] = useState<any>([]);
  const [currentList, setCurrentList] = useState<any>([]);
  const [currentListTemp, setCurrentListTemp] = useState<any>([]);
  const [refresh, setRefresh] = useState<any>(false);
  const [selectUnSelectAll, setSelectUnSelectAll] = useState<any>(true);
  const [searchedValue, setSearchedValue] = useState("");
  const listOfListRef = useRef<any | null>(null);
  listOfListRef.current = listOfList;

  const gridDatatRef = useRef<any | null>(null);
  gridDatatRef.current = [...props.GridData];

  const [checboxListWidth, setChecboxListWidth] = useState(0);

  let excludeColumnsList = ["", "MENA Average"," ",];

  const componentRef = useRef<any>(null);
  const [showList, setShowList] = useState<any>(false);

  const showListRef = useRef<any | null>(null);
  showListRef.current = showList;

  const [columnName, setColumnName] = useState(props.ColumnName);

  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the component's DOM node
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        const functionName = event.target.getAttribute("data-function");
        if (functionName === null) {
          setShowList(false);
          showListRef.current = false;
        } else {
          setShowList(true);
          showListRef.current = true;
        }
      } else {
        setShowList(true);
        showListRef.current = true;
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setColumnName(props.ColumnName);
  }, [props.ColumnName]);

  useEffect(() => {
    if (columnName == "") {
      setShowList(false);
      showListRef.current = false;
    }else{
      setShowList(true);
      showListRef.current = true;
    }
  }, [columnName]);

  useEffect(() => {
    let l_checboxListWidth: any =
      document.getElementById("checklistid")?.clientWidth;

    if (props.Orientation === "Center") {
      l_checboxListWidth = l_checboxListWidth / 2;
    } else if (props.Orientation === "Right") {
      l_checboxListWidth = l_checboxListWidth;
    } else if (props.Orientation === "Left") {
      l_checboxListWidth = 0;
    }

    if (
      props.ColumnOrientation &&
      props.ColumnOrientation.length &&
      props.ColumnName !== ""
    ) {
      for (let i = 0; i < props.ColumnOrientation.length; i++) {
        if (props.ColumnName === props.ColumnOrientation[i].Name) {
          l_checboxListWidth =
            document.getElementById("checklistid")?.clientWidth;
          if (props.ColumnOrientation[i].Orientation === "Center") {
            l_checboxListWidth = l_checboxListWidth / 2;
          } else if (props.ColumnOrientation[i].Orientation === "Right") {
            l_checboxListWidth = l_checboxListWidth;
          } else if (props.ColumnOrientation[i].Orientation === "Left") {
            l_checboxListWidth = 0;
          }
        }
      }
    }

    setChecboxListWidth(l_checboxListWidth);
  }, [currentList]);

  useEffect(() => {
    setSearchedValue("");
    makeLists();
  }, [props.ColumnName, props.GridData]);

  useEffect(() => {
    if (props.GridData && props.GridData.length > 0) {
      filterData();
    }
  }, [props.RefreshFilters]);

  function makeLists() {
    let listFound = false;
    if (
      props.ColumnName !== "" &&
      props.GridData &&
      props.GridData.length > 0
    ) {
      setRefresh(!refresh);
      for (let i = 0; i < listOfList.length; i++) {
        if (listOfList[i].Name === props.ColumnName) {
          listFound = true;
          setCurrentList([...listOfList[i].List]);
          setCurrentListTemp([...listOfList[i].List]);
          checkSelectUnselectAll(listOfList[i].List);
          break;
        } else {
          listFound = false;
        }
      }
      if (!listFound) {
        let newList = getUniqueRecordsAgainstNthColumn(
          props.GridData,
          props.ColumnName
        );
        if (newList && newList.length > 0) {
          let tempList = [];
          for (let i = 0; i < newList.length; i++) {
            let obj = {} as any;
            obj.Name = newList[i];
            obj.IsSelected = true;
            tempList.push(obj);
          }

          let obj = {} as any;
          obj.Name = props.ColumnName;
          obj.List = tempList;
          setListOfList((prevArray: any) => [...prevArray, obj]);
          setCurrentList([...tempList]);
          setCurrentListTemp([...tempList]);
          checkSelectUnselectAll(tempList);
        }
      }
    }
  }

  function updateListdata(index: number) {
    const l_currentList = [...currentList];
    l_currentList[index].IsSelected = !l_currentList[index].IsSelected;
    checkSelectUnselectAll(l_currentList);
    setCurrentList(l_currentList);
  }

  function checkSelectUnselectAll(l_currentList: any) {
    let allChecked = true;
    for (let i = 0; i < l_currentList.length; i++) {
      if (l_currentList[i].IsSelected === false) {
        allChecked = false;
        break;
      }
    }
    setSelectUnSelectAll(allChecked);
  }

  function selectUnselectAll(event: any) {
    const l_currentList = [...currentList];
    if (event.target.checked) {
      //select all
      setSelectUnSelectAll(true);
      for (let i = 0; i < l_currentList.length; i++) {
        l_currentList[i].IsSelected = true;
      }
    } else {
      //unselect all
      setSelectUnSelectAll(false);
      for (let i = 0; i < l_currentList.length; i++) {
        l_currentList[i].IsSelected = false;
      }
    }
    setRefresh(!refresh);
    setCurrentList(l_currentList);
  }

  function filterData() {
    let tempListOfList = [];
    tempListOfList = listOfList;
    for (let i = 0; i < tempListOfList.length; i++) {
      if (tempListOfList[i].Name === props.ColumnName) {
        tempListOfList[i].List = currentList;
        setListOfList(tempListOfList);
        listOfListRef.current = tempListOfList;
        break;
      }
    }

    let thisGridData = [...gridDatatRef.current];
    for (let index = 0; index < thisGridData.length; index++) {
      thisGridData[index].IsExcluded = false;
    }

    for (let i = 0; i < listOfListRef.current.length; i++) {
      for (let j = 0; j < listOfListRef.current[i].List.length; j++) {
        for (let k = 0; k < thisGridData.length; k++) {
          if (
            thisGridData[k][listOfListRef.current[i].Name] ===
              listOfListRef.current[i].List[j].Name &&
            listOfListRef.current[i].List[j].IsSelected === false
          ) {
            thisGridData[k].IsExcluded = true;
          }
        }
      }
    }

    props.ColumnFilterCheckboxListCallback(thisGridData);
  }

  useEffect(() => {
    if (listOfList.length > 0) {
      props.ReturnAllFilterdLists(listOfList);
    }
  }, [props.GetFilteredLists]);

  useEffect(() => {
    filterByKeyUp();
    // if (searchedValue !== "") {
    // }else{

    // }
  }, [searchedValue]);

  function filterByKeyUp() {
    let filterArray: any = [];
    for (let i = 0; i < listOfListRef.current.length; i++) {
      if (listOfListRef.current[i].Name === props.ColumnName) {
        filterArray = filterByValue(
          listOfListRef.current[i].List,
          searchedValue
        );
      }
    }
    setCurrentList(filterArray);
  }

  function filterByValue(array: any, value: string) {
    return array.filter(
      (data: any) =>
        JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  return (
    <div
      ref={componentRef}
      id="checkboxFilterList"
      className={`${showListRef.current  === false ? "no-display" : "show-display"}`}
      style={{
        position: "absolute",
        top: props.ClickPosition.y,
        left: props.ClickPosition.x + checboxListWidth,
      }}
    >
      <div className="check-list" id="checklistid">
        <input
          className="input-search"
          value={searchedValue}
          onChange={(e: any) => setSearchedValue(e.target.value)}
          placeholder="Search"
        />
        <div>
          <div className="list-scroll">
            <div className="check-item">
              <input
                type="checkbox"
                value={selectUnSelectAll}
                checked={selectUnSelectAll}
                onChange={(e: any) => selectUnselectAll(e)}
              />
              <span>Select/UnSelect All</span>
            </div>

            {currentList &&
              currentList.map((item: any, index: any) => (
                <React.Fragment key={props.ColumnName + index}>
                  {!checkIfItemIsIntheList(item.Name, excludeColumnsList) && (
                    <div className="check-item">
                      <input
                        type="checkbox"
                        value={item.IsSelected}
                        checked={item.IsSelected}
                        onChange={(e: any) => updateListdata(index)}
                      />
                      <span>{item.Name}</span>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
        <button onClick={() => filterData()}>Filter</button>
      </div>
    </div>
  );
}

export default ColumnFilterCheckboxList;
